import React, { useEffect } from 'react';
import styles from './ModalForm.module.css';
import { useTranslation } from 'react-i18next';

import { Button, Select, TextInput, Textarea } from '@mantine/core';
import { useForm } from '@mantine/form';

const Form = ({ onClose, updateClaim, claim, fetchClaim, fetchClaims }) => {
  const { t } = useTranslation();
  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      organizationName: claim.organizationName,
      placeName: claim.placeName,
      googleLink: claim.googleLink,
      placeKey: claim.placeKey,
      comment: claim.comment,
      id: claim.id,
      status: claim.status
    },

    validate: {
      placeName: (value) => (value?.length > 0 ? null : t('empty.invalid')),
      googleLink: (value) => (value?.length > 0 ? null : t('empty.invalid')),
    },
  });

  const fetch = async () => {
    const data = await fetchClaim(claim.id);

    form.setValues({ comment: data.comment, googleLink: data.googleLink })
  }

  useEffect(() => {
    fetch();
  }, []);

  const handleSubmit = async (values) => {
    const { placeKey, status } = values;
    if (status === 'APPROVED' && !placeKey) {
      form.setErrors({
        placeKey: t('empty.invalid')
      })

      return;
    }

    const { errors } = await updateClaim(values);

    if (errors?.length > 0) {
      errors.forEach(error => {
        switch (error.code) {
          case 'P301':
            form.setErrors({
              placeKey: t('placekey.error')
            })

            break;

          case 'B34':
            form.setErrors({
              placeKey: t('placekey.error.notFound')
            })

            break;

          default:
            break;
        }
      })
    } else {
      if (status === 'APPROVED') {
        window.gtag('event', 'action_application_approve')
      }

      if (status === 'REJECTED ') {
        window.gtag('event', 'action_application_rejected')
      }

      await fetchClaims();

      onClose();
    }
  }

  const data = [
    { value: 'ON_REVIEW', label: t('claimStatue.option1') },
    { value: 'APPROVED', label: t('claimStatue.option2') },
    { value: 'REJECTED', label: t('claimStatue.option3') }
  ];

  return (
    <div className={styles.wrapper}>
      <form
        className={styles.form}
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <TextInput
          label={t('claim.title', { claim: '' })}
          key={form.key('id')}
          className={styles.disabledLabel}
          {...form.getInputProps('id')}
          disabled
        />

        <div className={styles.separator} />

        <TextInput
          label={t('company.title', { name: '' })}
          className={styles.disabledLabel}
          key={form.key('organizationName')}
          {...form.getInputProps('organizationName')}
          disabled
        />

        <div className={styles.separator} />

        <TextInput
          label={t('placeName.label')}
          placeholder={t('placeName.placeholder')}
          key={form.key('placeName')}
          {...form.getInputProps('placeName')}
          disabled
        />

        <div className={styles.separator} />

        <TextInput
          label={t('placeHref.label')}
          placeholder={t('placeHref.placeholder')}
          key={form.key('googleLink')}
          disabled
          {...form.getInputProps('googleLink')}
        />

        <div className={styles.separator} />

        <TextInput
          label={t('placekey.label')}
          placeholder={t('placekey.placeholder')}
          key={form.key('placeKey')}
          {...form.getInputProps('placeKey')}
        />

        <div className={styles.separator} />

        <Textarea
          label={t('comment.label')}
          placeholder={t('comment.placeholder')}
          key={form.key('comment')}
          {...form.getInputProps('comment')}
        />

        <div className={styles.separator} />

        <Select
          label={t('claimStatus.title')}
          data={data}
          {...form.getInputProps('status')}
        />

        <Button
          className={styles.button}
          fullWidth type="submit"
        >
          {t('save')}
        </Button>
      </form>
    </div >
  )
}

export default Form;
